'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp; /**
                                   * Created by li on 2016/4/7.
                                   */


var _reactRedux = require('react-redux');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _reactRouter = require('react-router');

var _productListPage = require('redux/modules/productListPage');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    userInfo: state.auth.userInfo,
    headerTxt: state.background.headerTxt
  };
}, (0, _extends3.default)({
  onInitFirstSecondItemId: _productListPage.initFirstSecondItemId,
  routerPush: _reactRouterRedux.push
}, authActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Header).call(this));

    _this.onYpwQCMouseOver = function () {
      var isYpwQcShow = _this.state.isYpwQcShow;

      _this.setState({
        isYpwQcShow: !isYpwQcShow
      });
    };

    _this.state = {
      userLoginFlipped: null,
      newMediumFlipped: null,
      experienceShopFlipped: null,
      shopLoginFlipped: null,
      isYpwQcShow: false,
      searchInputShow: false
      /*
       headerLink: [
       {url: '/home', txt: '丨 艺 • 艺品'},
       {url: '/customproductslist', txt: '丨 工 • 定制'},
       {url: '/servicesmarket', txt: '丨 美 • 服务'}
       ] */
    };
    return _this;
  }

  (0, _createClass3.default)(Header, [{
    key: 'onInitFirstSecondItemId',
    value: function onInitFirstSecondItemId() {
      var onInitFirstSecondItemId = this.props.onInitFirstSecondItemId;

      if (onInitFirstSecondItemId) {
        onInitFirstSecondItemId();
      }
    }
  }, {
    key: 'flipClick',
    value: function flipClick(child) {
      var routerPush = this.props.routerPush; // userLoginClick

      switch (child) {
        case 'userLogin':
          routerPush('/login');
          break;
        case 'newMedium':
          routerPush('/bvlogin');
          // window.location.href = 'http://www.goto720.com/zgypw/bwg.html';
          // window.open('http://www.goto720.com/zgypw/bwg.html');
          /* const { user, userInfo, showUserLoginModel, getUserInfo} = this.props;
           if (!!user) {
           if (!!userInfo) {
           console.log(userInfo);
           if (userInfo.info[0].isNewMedium && userInfo.info[0].isNewMedium === '1') {
           routerPush('/newmediumcenter');
           } else {
           routerPush('/bvlogin');
           }
           } else {
           getUserInfo().then((nextData)=> {
           // console.log(JSON.stringify(nextData));
           // routerPush('/newmediumcenter');
           if (nextData.info[0].isNewMedium && nextData.info[0].isNewMedium === '1') {
           routerPush('/newmediumcenter');
           } else {
           routerPush('/bvlogin');
           }
           });
           }
           } else {
           showUserLoginModel();
           } */
          break;
        case 'experienceShop':
          routerPush('/experienceshoplogin');
          break;
        case 'shopLogin':
          routerPush('/shoplogin');
          break;
        default:
          return;
      }
    }
  }, {
    key: 'mouseOver',
    value: function mouseOver(child) {
      switch (child) {
        case 'userLogin':
          this.setState({
            userLoginFlipped: true
          });
          break;
        case 'newMedium':
          this.setState({
            newMediumFlipped: true
          });
          break;
        case 'experienceShop':
          this.setState({
            experienceShopFlipped: true
          });
          break;
        case 'shopLogin':
          this.setState({
            shopLoginFlipped: true
          });
          break;
        default:
          return;
      }
    }
  }, {
    key: 'mouseLeave',
    value: function mouseLeave(child) {
      switch (child) {
        case 'userLogin':
          this.setState({
            userLoginFlipped: false
          });
          break;
        case 'newMedium':
          this.setState({
            newMediumFlipped: false
          });
          break;
        case 'experienceShop':
          this.setState({
            experienceShopFlipped: false
          });
          break;
        case 'shopLogin':
          this.setState({
            shopLoginFlipped: false
          });
          break;
        default:
          return;
      }
    }
  }, {
    key: 'searchBtnClick',
    value: function searchBtnClick() {
      var input = this.refs.searchInput.value;
      // const {routerPush, user, showUserLoginModel} = this.props;
      var routerPush = this.props.routerPush;
      var searchInputShow = this.state.searchInputShow;

      if (searchInputShow) {
        if (!Boolean(input)) {
          this.setState({
            searchInputShow: false
          });
        } else {
          routerPush('/search?findValue=' + input);
          /*  if (!!user) {
           routerPush('/search?findValue=' + input);
           } else {
           showUserLoginModel();
           } */
        }
      } else {
          this.setState({
            searchInputShow: true
          });
        }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.keyCode === 13) {
        this.searchBtnClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Header.scss');
      var _props = this.props;
      var isBackGroundBlack = _props.isBackGroundBlack;
      var page = _props.page;
      var user = _props.user;
      var headerTxt = _props.headerTxt;
      var location = _props.location;
      var searchInputShow = this.state.searchInputShow;
      // console.log(location);
      // console.log(user);
      // const {isYpwQcShow} = this.state;
      // console.log(isYpwQcShow);
      /* const { headerLink } = this.state;
       const linktxt = headerLink.find((item)=>(location.pathname.indexOf(item.url) >= 0 )); */

      return _react2.default.createElement(
        'div',
        { style: { position: 'relative' } },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/', className: styles.logo },
          _react2.default.createElement('img', {
            src: isBackGroundBlack ? 'http://tupian.goeasy.cn:9999/yipinwang/header/logoWeight.jpg' : 'http://tupian.goeasy.cn:9999/yipinwang/header/logoLight.png',
            alt: '' })
        ),
        _react2.default.createElement(
          _components.FlipCard,
          { goeasyTag: 'userLogin', onFrontClick: this.flipClick.bind(this),
            onFrontMouseOver: this.mouseOver.bind(this),
            componentMouseLeave: this.mouseLeave.bind(this),
            flipped: this.state.userLoginFlipped },
          _react2.default.createElement(
            'div',
            { className: styles.deng },
            _react2.default.createElement('img', {
              src: !!user ? 'http://tupian.goeasy.cn:9999/yipinwang/newimg_red.jpg' : 'http://tupian.goeasy.cn:9999/yipinwang/header/login.jpg',
              alt: '' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.deng + ' ' + styles.opi },
            _react2.default.createElement('img', {
              src: !!user ? 'http://tupian.goeasy.cn:9999/yipinwang/header/userLogined.jpg' : 'http://tupian.goeasy.cn:9999/yipinwang/header/userLogin.jpg',
              alt: '' })
          )
        ),
        _react2.default.createElement(
          _components.FlipCard,
          { goeasyTag: 'newMedium', onFrontClick: this.flipClick.bind(this),
            onFrontMouseOver: this.mouseOver.bind(this),
            componentMouseLeave: this.mouseLeave.bind(this),
            flipped: this.state.newMediumFlipped },
          _react2.default.createElement(
            'a',
            { className: styles.experienceShop },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/newMedium.png', alt: '' })
          ),
          _react2.default.createElement(
            'a',
            { className: styles.experienceShop + ' ' + styles.opi },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/newMediumLogin.jpg', alt: '' })
          )
        ),
        _react2.default.createElement(
          _components.FlipCard,
          { goeasyTag: 'experienceShop', onFrontClick: this.flipClick.bind(this),
            onFrontMouseOver: this.mouseOver.bind(this),
            componentMouseLeave: this.mouseLeave.bind(this),
            flipped: this.state.experienceShopFlipped },
          _react2.default.createElement(
            'div',
            { className: styles.commercial },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/experienceShop.jpg',
              alt: '' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.commercial + ' ' + styles.opi, src: 'http://www.goto720.com/zgypw/bwg.html',
              target: '_blank' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/experienceShopLogin.jpg', alt: '' })
          )
        ),
        _react2.default.createElement(
          _components.FlipCard,
          { goeasyTag: 'shopLogin', onFrontClick: this.flipClick.bind(this),
            onFrontMouseOver: this.mouseOver.bind(this),
            componentMouseLeave: this.mouseLeave.bind(this),
            flipped: this.state.shopLoginFlipped },
          _react2.default.createElement(
            'a',
            { className: styles.bow },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/authorization.jpg', alt: '' })
          ),
          _react2.default.createElement(
            'a',
            { className: styles.bow + ' ' + styles.opi },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/shopLogin.jpg', alt: '' })
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.CenterGr, style: page === 'main' ? { display: 'none' } : { marginTop: '19px' } },
          _react2.default.createElement(
            'div',
            { className: styles.InfoTop },
            _react2.default.createElement(
              'div',
              { className: styles.InfoTopA, style: { width: '752px', backgroundColor: '#333333' } },
              _react2.default.createElement(
                'a',
                { // to="/"
                  className: styles.ConterTer,
                  style: { background: 'none', paddingLeft: '23px' } },
                headerTxt
              ),
              typeof location !== 'undefined' && location.pathname === '/' ? _react2.default.createElement(
                'a',
                { className: styles.sou_box, onClick: this.searchBtnClick.bind(this) },
                searchInputShow ? '搜索' : _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/images/sou_img.png', alt: '' })
              ) : '',
              typeof location !== 'undefined' && location.pathname === '/' ? _react2.default.createElement('input', { type: 'text', className: styles.input_sou,
                ref: 'searchInput',
                onKeyDown: this.handleKeyDown.bind(this),
                style: searchInputShow ? { width: '305px', paddingLeft: '12px' } : { width: '0px', paddingLeft: '0px' },
                placeholder: '请输入搜索内容' }) : ''
            ),
            _react2.default.createElement(
              'a',
              { // to="/login"
                // onClick={()=>{window.location.href = 'http://baike.craftschina.cn/';}}
                //    onMouseOver={()=>this.mouseOver('userLogin')}
                //    onMouseLeave={()=>this.mouseLeave('userLogin')}
                className: styles.registerTopLink },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/yuxuan/menu_ul_ing_4.jpg',
                alt: '' })
            ),
            _react2.default.createElement(
              'a',
              { // to="/shoplogin"
                className: styles.registerTopLink
                // onMouseOver={()=>this.mouseOver('shopLogin')}
                // onMouseLeave={()=>this.mouseLeave('shopLogin')}
              },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/yuxuan/menu_ul_ing_3.jpg', alt: '' })
            ),
            _react2.default.createElement(
              'a',
              { // to="/experienceshop"
                className: styles.registerTopLink
                // onClick={this.onInitFirstSecondItemId.bind(this)}
                // onMouseOver={()=>this.mouseOver('experienceShop')}
                // onMouseLeave={()=>this.mouseLeave('experienceShop')}
              },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/yuxuan/menu_ul_ing_2.jpg',
                alt: '' })
            ),
            _react2.default.createElement(
              'a',
              { // to="/newmedium"
                className: styles.registerTopLink
                // onClick={this.onInitFirstSecondItemId.bind(this)}
                // onMouseOver={()=>this.mouseOver('newMedium')}
                // onMouseLeave={()=>this.mouseLeave('newMedium')}
              },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/yuxuan/menu_ul_ing_1.jpg', alt: '' })
            )
          )
        )
      );
    }
  }]);
  return Header;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  user: _react.PropTypes.object,
  userInfo: _react.PropTypes.object,
  isBackGroundBlack: _react.PropTypes.bool,
  loginBtnClick: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  page: _react.PropTypes.string,
  location: _react.PropTypes.object,
  onInitFirstSecondItemId: _react.PropTypes.func,
  headerTxt: _react.PropTypes.string,
  showUserLoginModel: _react.PropTypes.func,
  getUserInfo: _react.PropTypes.func
}, _temp)) || _class);
exports.default = Header;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Header/Header.js
 ** module id = 80
 ** module chunks = 0
 **/